<fury-page>
  <fury-title class="title">
    <h2>{{!coveredItemId ? 'Add' : 'Edit'}} covered items</h2>
  </fury-title>
</fury-page>
<div fxLayout="column" fxLayoutAlign="start center">
  <div [@fadeInUp] class="card">
    <form [formGroup]="coveredItemForm">
      <div class="content" fxLayout="column" fxLayoutGap="8px">
            <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
            style="margin-bottom: 20px;align-items: baseline; width: 100% !important;">
            <div class="flex">
              <div class="innerdiv">
                <div class="uploadsec">
                  <div class="imgsec">
                    <img [src]="imagestoupload ?  imagestoupload : '../../../../../assets/img/no_thumbnail.jpg'" alt="">
                   
                  </div>
                  <div class="uploadbtnsec">
                    <input type="file" #galleryImage (change)="onImageUpload($event)" accept=".png, .jpg, .jpeg"
                      style="display:none">
                    <button type="button" class="uploadfilebtn" mat-button (click)="galleryImage.click()">Upload Image</button>
                  </div>
                </div>
              </div>
            </div>
            </fxLayout>

            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Title</mat-label>
              <input matInput placeholder="Title" formControlName="title">
              <mat-error
                *ngIf="coveredItemForm.controls['title'].touched && coveredItemForm.controls['title'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Description</mat-label>
              <textarea matInput placeholder="Description" formControlName="description" rows="5">
                </textarea>
              <mat-error
                *ngIf="coveredItemForm.controls['description'].touched && coveredItemForm.controls['description'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>

            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Average Cost of Repair</mat-label>
                <span class="valuePadding doller__sign__holder"><input matInput placeholder="Average Cost of Repair"
                    (keypress)="isNumberKey($event)" formControlName="averageCostForRepair"></span>
              </mat-form-field>
              
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Average Cost of Replacement</mat-label>
                <span class="valuePadding doller__sign__holder"><input matInput
                    placeholder="Average Cost of Replacement" (keypress)="isNumberKey($event)"
                    formControlName="averageCostForReplacement"></span>
              </mat-form-field>
            </div>
            <!-- Coverage Highlights -->
            <mat-form-field fxFlex="auto" class="example-chip-list" appearance="outline">
              <mat-label>Coverage Highlights</mat-label>
              <mat-chip-list #coverageHighlight>
                <input placeholder="Coverage Highlights" [matChipInputFor]="coverageHighlight" [matChipInputAddOnBlur]="true"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addChip($event, 'coverageHighlights')" class="chipinput">
                <div class="fullwchip" *ngIf="coveredItemForm.value.coverageHighlights?.length > 0">
                  <mat-chip *ngFor="let item of coveredItemForm.value.coverageHighlights" [selectable]="true" (removed)="removeChip(item, 'coverageHighlights')"
                    [removable]="true">
                    {{item}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </div>
              </mat-chip-list>
            </mat-form-field>
            <!-- Coverage Highlights -->
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Additional Information</mat-label>
              <textarea matInput placeholder="Additional Information" formControlName="additionalInformation"></textarea>
            </mat-form-field>
           
            <!-- What we cover -->
            
              <mat-form-field class="example-chip-list" fxFlex="auto" appearance="outline">
                <mat-label>What We Cover</mat-label>
                <textarea matInput placeholder="What We Cover" class="chipinput"
                  formControlName="whatWeCover"></textarea>
                <mat-error
                  *ngIf="coveredItemForm.controls['whatWeCover'].touched && coveredItemForm.controls['whatWeCover'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
            
            <!-- What we cover -->

            <!-- Type of systems we cover -->
            
              <mat-form-field class="example-chip-list" fxFlex="auto" appearance="outline">
                <mat-label>Type of Systems We Cover</mat-label>
                <mat-chip-list #systemCovered>
                  <input placeholder="Type of systems we cover"  [matChipInputFor]="systemCovered" [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addChip($event, 'typeOfSystemWeCover')"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" class="chipinput">
                  <div class="fullwchip" *ngIf="coveredItemForm.value.typeOfSystemWeCover?.length > 0">
                    <mat-chip *ngFor="let item of coveredItemForm.value.typeOfSystemWeCover" [selectable]="true" (removed)="removeChip(item, 'typeOfSystemWeCover')"
                      [removable]="true">
                      {{item}}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </div>
                </mat-chip-list>
              </mat-form-field>
           
            <!-- Type of systems we cover -->
            
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Additional Information for What We Cover</mat-label>
                <textarea matInput placeholder="Additional Information for What we cover"
                  formControlName="additionalInformationForWhatWeCover">
                    </textarea>
              </mat-form-field>
           
            <!-- Not Covered -->
           
              <mat-form-field class="example-chip-list" fxFlex="auto" appearance="outline">
                <mat-label>Not Covered</mat-label>
                <textarea matInput placeholder="Not Covered" class="chipinput"
                  formControlName="notCovered"></textarea>
              </mat-form-field>
            
            <!-- Not Covered -->
            <!-- systems types are not covered -->
            
              <mat-form-field class="example-chip-list" fxFlex="auto" appearance="outline">
                <mat-label>The Following Systems Types are not Covered</mat-label>
                <mat-chip-list #notCoverdSystemtype aria-label="Fruit selection">
                  <input placeholder="The following systems types are not covered" (matChipInputTokenEnd)="addChip($event, 'followingSystemTypesNotCovered')"
                    [matChipInputFor]="notCoverdSystemtype" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true" class="chipinput">
                  <div class="fullwchip" *ngIf="coveredItemForm.value.followingSystemTypesNotCovered?.length > 0">
                    <mat-chip *ngFor="let item of coveredItemForm.value.followingSystemTypesNotCovered" [selectable]="true" (removed)="removeChip(item, 'followingSystemTypesNotCovered')"
                      [removable]="true">
                      {{item}}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </div>
                </mat-chip-list>
              </mat-form-field>
           
            <!-- systems types are not covered -->
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Additional Information for not covered</mat-label>
                <textarea matInput placeholder="Additional Information for not covered"
                  formControlName="additionalInformationForNotCovered">
                </textarea>
              </mat-form-field>

              <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Freon Coverage</mat-label>
                    <input matInput placeholder="Freon Coverage" formControlName="freonCoverage">
                  </mat-form-field>
                
              
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Maximum Coverage</mat-label>
                    <input matInput placeholder="Maximum Coverage" formControlName="maximumCoverage">
                  </mat-form-field>
               
              </div>
              <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
               
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Standard Price</mat-label>
                    <span class="valuePadding doller__sign__holder"><input matInput placeholder="Standard Price"
                        formControlName="standardPrice" (keypress)="isNumberKey($event)"></span>
                  </mat-form-field>
                
  
              
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Custom Price</mat-label>
                    <span class="valuePadding doller__sign__holder"><input matInput placeholder="Custom Price"
                        formControlName="customPrice" (keypress)="isNumberKey($event)"></span>
                  </mat-form-field>
              
              </div>
              <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Maximum Coverage Increase Fee</mat-label>
                    <span class="valuePadding input-holder"><input matInput placeholder="Maximum Coverage Increase Fee"
                        formControlName="maximumCoverageIncreaseFee" (keypress)="isNumberKey($event)"></span>
                        <mat-error
                        *ngIf="coveredItemForm.controls['maximumCoverageIncreaseFee'].hasError('min') ||coveredItemForm.controls['maximumCoverageIncreaseFee'].hasError('max')">
                        The value must be within 0% - 100%.</mat-error>
                  </mat-form-field>
                
                
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Maximum Coverage Decrease Fee</mat-label>
                    <span class="valuePadding input-holder"><input matInput placeholder="Maximum Coverage Decrease Fee"
                        formControlName="maximumCoverageDecreaseFee" (keypress)="isNumberKey($event)"></span>
                        <mat-error
                        *ngIf="coveredItemForm.controls['maximumCoverageDecreaseFee'].hasError('min') ||coveredItemForm.controls['maximumCoverageDecreaseFee'].hasError('max')">
                        The value must be within 0% - 100%.</mat-error>
                  </mat-form-field>
               
              </div>
              <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Maximum Allowed Decrease</mat-label>
                    <span class="valuePadding doller__sign__holder"><input matInput
                        placeholder="Maximum Allowed Decrease" formControlName="maximumAllowedDecrease"
                        (keypress)="isNumberKey($event)"></span>
                  </mat-form-field>
               
                
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Maximum Allowed Increase</mat-label>
                    <span class="valuePadding doller__sign__holder"><input matInput
                        placeholder="Maximum Allowed Increase" formControlName="maximumAllowedIncrease"
                        (keypress)="isNumberKey($event)"></span>
                  </mat-form-field>
               
              </div>
              <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Item Removal Price</mat-label>
                    <span class="valuePadding doller__sign__holder"><input matInput placeholder="Item Removal Price"
                        formControlName="itemRemovalPrice" (keypress)="isNumberKey($event)"></span>
                  </mat-form-field>
            
               
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Item type</mat-label>
                    <mat-select formControlName="itemType">
                      <mat-option value="appliances">Appliances</mat-option>
                      <mat-option value="systems">Systems</mat-option>
                    </mat-select>
                    <mat-error
                    *ngIf="coveredItemForm.controls['itemType'].touched && coveredItemForm.controls['itemType'].hasError('required')">
                    This is a required field.</mat-error>
                  </mat-form-field>
              
              </div>
              <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                <mat-form-field fxFlex="auto" appearance="outline">
                  <mat-label>Plan Types</mat-label>
                  <mat-select multiple formControlName="planType" (ngModelChange)="onPlanTypeChange($event)">
                    <mat-option [value]="item?.planOptionalItemCategoryId" *ngFor="let item of planOptionalItemCategories">
                      {{item?.title}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="coveredItemForm.controls['planType'].touched && coveredItemForm.controls['planType'].hasError('required')">
                    This is a required field.
                  </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline"  *ngIf="isSelectedOptionalItem">
                  <mat-label>Main Plans</mat-label>
                  <mat-select multiple formControlName="coveredPlanIds">
                    <mat-option [value]="item?.planOptionalItemCategoryId" *ngFor="let item of optionalItem">
                      {{item?.title}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="coveredItemForm.controls['coveredPlanIds'].touched && coveredItemForm.controls['coveredPlanIds'].hasError('required')">
                    This is a required field.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="toggle-container">
                <mat-slide-toggle formControlName="isActive">Active</mat-slide-toggle>
                <mat-slide-toggle formControlName="allowedMultipleItem" *ngIf="isSelectedOptionalItem">Allow Multiple Item</mat-slide-toggle>
                <mat-slide-toggle formControlName="visibleToFrontend">Visible To Home Page</mat-slide-toggle>
              </div> 
              <div>
                <mat-checkbox formControlName="isClaim">For File Claim</mat-checkbox>
              </div> 
              <div>
                <mat-checkbox formControlName="forPopup">For Lead Popup</mat-checkbox>
              </div>     
            
      </div>
      <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <button mat-button type="button" class="sub-button" (click)="addCoveredItem()">{{!coveredItemId ? 'Add' : 'Update'}}</button>
        <button class="can-button" (click)="this.location.back()" mat-button>Cancel</button>
      </div>

     
    </form>
  </div>
</div>




